














import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class App extends Vue {
  activeItem = ''

  onMenuSelect (index: any) {
    this.activeItem = index
    this.$router.push(index)
  }

  @Watch('activeItem')
  watchActiveItem (newVal: any) {
    this.$router.push(newVal)
  }

  mounted () {
    this.activeItem = this.$route.path
    if (!this.activeItem || this.activeItem === '/') {
      this.activeItem = '/base-element'
    }
  }
}
